export default __webpack_public_path__ + "static/media/digitizePolygon.eb92719f.cur";